import QAGroupList from '@/data/qaGroup/view/list.vue'

const list = {
  path: '/qaGroup',
  name: 'qaGroup-list',
  component: QAGroupList
}

export default [list]
